module.exports = __webpack_public_path__ + "img/upmc1.b0ecde7a.png";